/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_DescriptionInputs */

const en_gc_home_description = /** @type {(inputs: Gc_Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The open-source spreadsheet from ArtCraft. Explore your numbers, find your formulas, and make room for better work.`)
};

const zh_gc_home_description = /** @type {(inputs: Gc_Home_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ArtCraft 开发的开源电子表格。探索数字、找到公式，为更好的工作腾出空间。`)
};

/**
* | output |
* | --- |
* | "The open-source spreadsheet from ArtCraft. Explore your numbers, find your formulas, and make room for better work." |
*
* @param {Gc_Home_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_description = /** @type {((inputs?: Gc_Home_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_description(inputs)
	return zh_gc_home_description(inputs)
});
export { gc_home_description as "gc.home.description" }